<template>
  <BjDialogList
    ref="dialogList"
    width="80%"
    :config="dialogConfig"
    :search-btn-hide="true"
    :show-tags="false"
    :multiple="null"
  />
</template>
<script>
export default {
  name: 'BjLogList',
  data() {
    return {
      defaultQuery: {},
      dialogConfig: this.$BjDialogListConfig['orderLogDefault'](),
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    init() {},
    show(info) {
      this.dialogConfig = info;
      this.$nextTick(() => {
        this.$refs.dialogList.show();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  .werp-img {
    width: 30px;
    height: 30px;
    margin-right: 5px;
  }
}
</style>
